import React, { useContext, useEffect, useState } from "react";
import {
  Check,
  Eye,
  X,
  Users,
  CreditCard,
  AlertTriangle,
  Package,
  UserMinus,
  Bell,
} from "lucide-react";
import DistributorMasterLayout from "../../../layouts/distributor/DistributorMasterLayout";
import "../../../assets/styles/distributor/DistributorNotifications.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const ICON_MAP = {
  subscription: { Icon: Users, color: "green" },
  payment: { Icon: CreditCard, color: "blue" },
  dispute: { Icon: AlertTriangle, color: "red" },
  supply: { Icon: Package, color: "teal" },
  cancel: { Icon: UserMinus, color: "orange" },
  overdue: { Icon: CreditCard, color: "red" },
};

const INITIAL_NOTIFS = [
  {
    id: 1,
    type: "subscription",
    title: "New Subscription Request",
    desc: "Hassan Ali has requested a milk subscription in DHA Phase 5",
    time: "2 hours ago",
    read: false,
    detail:
      "Hassan Ali from House 45, DHA Phase 5 has submitted a new milk subscription request. Requested daily quantity: 2L. Please review and approve or reject this request from the Customers section.",
    category: "Subscription",
  },
  {
    id: 2,
    type: "payment",
    title: "Payment Received",
    desc: "Ali Ahmed has paid PKR 3,600 for March billing",
    time: "5 hours ago",
    read: true,
    detail:
      "Ali Ahmed paid PKR 3,600 via Cash for March 2024 billing. Payment recorded at 2:30 PM today. Transaction ref: TXN-20240315-001.",
    category: "Payment",
  },
  {
    id: 3,
    type: "dispute",
    title: "New Dispute Filed",
    desc: "Sara Khan filed a dispute about short delivery",
    time: "1 day ago",
    read: true,
    detail:
      "Sara Khan (Gulberg III) has filed a dispute regarding short delivery on March 14, 2024.",
    category: "Dispute",
  },
  {
    id: 4,
    type: "supply",
    title: "Supply Received",
    desc: "Farmer Abdul delivered 50L of milk this morning",
    time: "1 day ago",
    read: true,
    detail:
      "Farmer Abdul delivered 50 liters of milk at 5:00 AM. Quality recorded as Good.",
    category: "Supply",
  },
  {
    id: 5,
    type: "cancel",
    title: "Subscription Cancelled",
    desc: "Fatima Noor has cancelled her subscription",
    time: "2 days ago",
    read: true,
    detail:
      "Fatima Noor (DHA Phase 6) has cancelled her milk subscription effective immediately.",
    category: "Subscription",
  },
  {
    id: 6,
    type: "overdue",
    title: "Payment Overdue",
    desc: "Usman Tariq's payment of PKR 2,400 is overdue by 5 days",
    time: "3 days ago",
    read: true,
    detail:
      "Usman Tariq (Johar Town) has not paid PKR 2,400 for March billing.",
    category: "Payment",
  },
];

const NotifDetailModal = ({ notif, onClose }) => {
  if (!notif) return null;
  const { Icon, color } = ICON_MAP[notif.type] || { Icon: Bell, color: "gray" };
  return (
    <div className="distNotif-overlay" onClick={onClose}>
      <div className="distNotif-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distNotif-modal-close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="distNotif-modal-header">
          <h4>{notif.title}</h4>
        </div>
        <div className="distNotif-modal-meta">
          <div className={`distNotif-modal-meta-icon ${color}`}>
            <Icon size={16} />
          </div>
          <div>
            <span className="distNotif-modal-meta-time">
              {notif.created_at || notif.time}
            </span>
            <span className="distNotif-modal-meta-cat">{notif.category}</span>
          </div>
        </div>
        <p className="distNotif-modal-body">
          {notif.description || notif.detail}
        </p>
        <button className="distNotif-modal-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

const NotificationsContent = () => {
  const [notifs, setNotifs] = useState(INITIAL_NOTIFS);
  const [apiNotifs, setApiNotifs] = useState([]);
  const [viewNotif, setViewNotif] = useState(null);
  const { baseUrl, loggedInDistributor } = useContext(AppContext);

  const isApi = apiNotifs.length > 0;
  const displayNotifs = isApi ? apiNotifs : notifs;
  const unreadCount = displayNotifs.filter(
    (n) => !(isApi ? n.status : n.read),
  ).length;

  /* Mark single as read */
  const markRead = (notif) => {
    // if (isApi) setApiNotifs(prev => prev.map(n => n.id === id ? { ...n, status: true } : n));
    // else       setNotifs(prev    => prev.map(n => n.id === id ? { ...n, read:   true } : n));
    const formData = new FormData();
    formData.append("id", notif.id);
    axios
      .post(`${baseUrl}/distributor/notification/markAsRead`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          //  setApiNotifs(response.data.notifications || []); // ✅ plural + crash guard
          viewAllNotifications();
        }
      })
      .catch((error) => {
        console.log("API unavailable, using mock data:", error.message);
      });
  };

  // };

  /* Mark all as read */
  const markAllRead = () => {
    // if (isApi) setApiNotifs(prev => prev.map(n => ({ ...n, status: true })));
    // else       setNotifs(prev    => prev.map(n => ({ ...n, read:   true })));
    const distributorId = localStorage.getItem("distributorId");

    const formData = new FormData();
    formData.append("mwdistributor_id", distributorId);

    axios
      .post(`${baseUrl}/distributor/notification/markAllRead`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);

        if (response.data.success === true) {
          // dobara notifications fetch karo
          viewAllNotifications(distributorId);
        }
      })
      .catch((error) => {
        console.log("Error marking all as read:", error);
      });
  };

  /* View + auto-mark-read */
  const handleView = (notif) => {
    markRead(notif.id);
    setViewNotif(notif);
  };

  const viewAllNotifications = (distributorId) => {
    const formData = new FormData();
    formData.append("mwdistributor_id", distributorId);

    axios
      .post(
        `${baseUrl}/distributor/notification/viewAllNotifications`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }, // ✅ fixed typo
        },
      )
      .then((response) => {
        if (response.data.success == true) {
          setApiNotifs(response.data.notifications); // ✅ plural
        }
      })
      .catch((error) => {
        console.log("API unavailable, using mock data:", error.message);
      });
  };

  /* API call */
  useEffect(() => {
    console.log("log from notification", loggedInDistributor);
    const distributorId = localStorage.getItem("distributorId");
    if (!distributorId) return;
    else {
      viewAllNotifications(distributorId);
    }
  }, []);

  return (
    <div className="distNotif-page">
      {/* Header */}
      <div className="distNotif-header-row">
        <div className="distNotif-title">
          <h2>Notifications</h2>
          <p>
            {/* {apiNotifs.length > 0 ? `${}`} */}
            {apiNotifs.length > 0
              ? `${apiNotifs.length} unread notification${apiNotifs.length > 1 ? "s" : ""}`
              : "All notifications read"}
          </p>
        </div>
        <button
          className="distNotif-markall-btn"
          onClick={markAllRead}
          disabled={apiNotifs.length === 0}
          style={{ opacity: apiNotifs.length === 0 ? 0.45 : 1 }}
        >
          <Check size={14} /> Mark All as Read
        </button>
      </div>

      {/* Notifications List */}
      <div className="distNotif-list-card">
        {/* {displayNotifs.length === 0 ? ( */}
        {apiNotifs.length === 0 ? (
          <div className="distNotif-empty">No notifications yet</div>
        ) : (
          // displayNotifs.map((notif) => {
          apiNotifs.map((notif) => {
            const type = notif.type || "subscription";
            // const isRead = isApi ? notif.status : notif.read;
            // const isRead = notif.status == "read" ? false : true;
            const isRead = notif.status == "unread" ? false : true;
            const { Icon, color } = ICON_MAP[type] || {
              Icon: Bell,
              color: "gray",
            }; // ✅ Icon now defined

            return (
              <div
                key={notif.id}
                className={`distNotif-row ${!isRead ? "unread" : ""}`}
                // className={`distNotif-row ${!notif.status ? "unread" : ""}`}
              >
                <div className={`distNotif-icon-wrap ${color}`}>
                  <Icon size={16} />
                </div>
                <div className="distNotif-text">
                  <span className="distNotif-type">{notif.title}</span>
                  <span className="distNotif-desc">{notif.description}</span>
                  <span className="distNotif-time">{notif.created_at}</span>
                </div>
                <div className="distNotif-actions">
                  {!isRead && <span className="distNotif-dot" />}
                  {!isRead && (
                    <button
                      className="distNotif-read-btn"
                      title="Mark as read"
                      onClick={() => markRead(notif)}
                    >
                      <Check size={16} />
                    </button>
                  )}
                  {/* <button className="distNotif-view-btn" title="View details" onClick={() => handleView(notif)}>
                    <Eye size={16}/>
                  </button> */}
                </div>
              </div>
            );
          })
        )}
      </div>

      {viewNotif && (
        <NotifDetailModal
          notif={viewNotif}
          onClose={() => setViewNotif(null)}
        />
      )}
    </div>
  );
};

const DistributorNotifications = () => (
  <DistributorMasterLayout>
    <NotificationsContent />
  </DistributorMasterLayout>
);

export default DistributorNotifications;
